export default "__VITE_ASSET__DfwheeHC__"